<template>
  <div class="input-wrapper">
    <input
      v-bind="$attrs"
      :id="actualId"
      v-on="proxiedListeners"
      class="input"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keydown="onKeydown"
    />
    <label :for="actualId" class="suffix">mm</label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: null
  },
  computed: {
    proxiedListeners() {
      // eslint-disable-next-line no-unused-vars
      let { input, ...listeners } = this.$listeners

      return listeners
    },
    actualId: vm =>
      vm.$attrs.id ??
      `input-${Math.round(Math.random() * 10 ** 9).toString(16)}`
  },
  methods: {
    getPrecision(value) {
      return String(value).match(/\.(.*)$/)?.[1].length ?? 0
    },
    round(value, precision) {
      return Math.round(value * 10 ** precision) / 10 ** precision
    },
    onKeydown(event) {
      if (this.$attrs.type !== 'number') return

      let numberValue = this.value === '' ? NaN : Number(this.value)
      let min = Number(this.$attrs.min) || -Infinity
      let max = Number(this.$attrs.max) || Infinity
      let practicalMin = Math.ceil(
        Number.isFinite(min) ? min : Math.min(0, max)
      )
      let step = 1
      if (event.altKey) {
        step = 0.1
      } else if (event.shiftKey) {
        step = 10
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault()
        if (isNaN(numberValue)) {
          this.$emit('input', practicalMin)
        } else {
          this.$emit(
            'input',
            Math.max(
              this.round(
                numberValue - step,
                Math.max(
                  this.getPrecision(numberValue),
                  this.getPrecision(step)
                )
              ),
              practicalMin
            )
          )
        }
      } else if (event.key === 'ArrowUp') {
        event.preventDefault()
        if (isNaN(numberValue)) {
          this.$emit('input', practicalMin)
        } else {
          this.$emit(
            'input',
            Math.min(
              this.round(
                numberValue + step,
                Math.max(
                  this.getPrecision(numberValue),
                  this.getPrecision(step)
                )
              ),
              max
            )
          )
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  display: flex;
  align-items: baseline;
  background: white;

  &:focus-within {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
}

.input {
  min-width: 20px;
  flex-grow: 1;
  width: 0;
  font: inherit;
  word-spacing: inherit;
  letter-spacing: inherit;
  background: none;
  border: none;
  margin: 0;
  padding: 0.35em 0 0.35em 0.8em;
  color: #575757;

  &:focus {
    outline: none;
  }
}

.suffix {
  color: var(--strong-accent);
  cursor: text;
  padding: 0.35em 0.8em;
}

.input,
.suffix {
  line-height: 1;
}
</style>
